export default __webpack_public_path__ + "static/media/题目批量导入模板.1ee6990f.xlsx";